module.exports = __webpack_public_path__ + "img/googleauth.323529f.png";